<template>
  <div class="card">
    <div class="card-header">
      <div class="row checkbox pb-3">
        <label class="customradio" :for="id">
          <span class="radiotextsty">{{ name }}</span>
          <input ref="componentName" :disabled="loading"
                 type="radio"
                 :id="id"
                 :name="name"
                 v-model="selectedPaymentMethod"
                 :value="componentName"
                 @change="paymentMethodChange"
                 :class="{ 'active': this.isActive }"
                 class="ticket_delivery_selector js-delivery-radio">
          <span class="checkmark"></span>
        </label>
      </div>
    </div>
    <div class="card-body" v-show="isActive && hasBody">
      <div class="row">
        <component :selected="selected"
                   :paymentMethod="paymentMethod"
                   v-on="$listeners"
                   :isActive="isActive"
                   :publicKey="publicKey"
                   :is="componentName">
        </component>
      </div>
    </div>
  </div>
</template>
<script>

import {mapFields} from "vuex-map-fields";
import BankTransfer from "./BankTransfer";
import CreditCardStripe from "./CreditCardStripe";

export default {
  name: 'tab',
  props: {
    id: {required: false},
    name: {required: true},
    componentName: {required: true},
    selected: {default: false},
    publicKey: String,
  },
  components: {
    BankTransfer,
    CreditCardStripe,
  },
  data() {
    return {
      paymentMethod: null,
    }
  },
  methods: {
    paymentMethodChange(e) {
      const self = this;
      this.paymentMethods.forEach(function (paymentMethod) {
        if (paymentMethod.key === e.target.value) {
          self.paymentMethod = paymentMethod;
        }
      })
    },
    hasBody() {
      return this.$children[0] ? this.$children[0].hasBody : false;
    }
  },
  computed: {
    ...mapFields([
      'selectedPaymentMethod',
      'invoices',
      'paymentMethods',
      'loading',
    ]),
    isActive() {
      return this.selectedPaymentMethod === this.componentName;
    },
  },
}
</script>
